import { render, staticRenderFns } from "./IntradayBox.vue?vue&type=template&id=60e8fdbc&scoped=true"
import script from "./IntradayBox.vue?vue&type=script&lang=js"
export * from "./IntradayBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8fdbc",
  null
  
)

export default component.exports